import styled from '@emotion/styled';

const Container = styled.div<{ opacity?: number }>`
  display: flex;
  flex-direction: column;
  border: 1px solid #c9cbcd;
  border-radius: 6px;
  background: #ffffff;
  opacity: ${({ opacity = 0.5 }) => opacity};
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 32px;
`;

const DisabledAdsWarningContainer = styled(ContentContainer)`
  justify-content: center;
  padding: 14px 32px;
  border-top: 1px solid #c9cbcd;
  p {
    color: #7f8287;
  }
`;

const IconWrapper = styled.div<{ fillColor: string }>`
  display: flex;
  align-items: center;
  width: 64px;
  height: 64px;
  margin-right: 20px;
  border-radius: 50%;
  background-color: ${({ fillColor }) => fillColor};

  div {
    svg {
      width: 46px;
      height: 46px;
    }
  }
`;

const Info = styled.div<{ hasError: boolean }>`
  flex: 1;
  font-size: 1.6rem;
  h3,
  p {
    color: ${({ hasError }) => (hasError ? '#E54751' : '#7f8287')};
  }
  h3 {
    margin: 0 0 3px;
    font-size: 1.6rem;
  }
`;

const ModuleHeader = styled.h3`
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 20px;
`;

export {
  Container,
  ContentContainer,
  DisabledAdsWarningContainer,
  IconWrapper,
  Info,
  ModuleHeader,
};
